import { Avatar } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CallUnderDescriptionBanner } from 'shared/components/CallUnderDescriptionBanner';
import {
  AvatarWrapper,
  CallUnderDescriptionBannerRedesigned,
} from 'shared/components/CallUnderDescriptionBannerRedesigned';
import { IconCoversation } from 'shared/components/CallUnderDescriptionBannerRedesigned/IconCoversation';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { selectAgentAvatarUrl } from 'shared/selectors/offerData/agent';

import { PhonesContainer } from './parts';

interface ICallUnderDescriptionBannerContainerProps {
  isRedesignedBlock?: boolean;
}

export function CallUnderDescriptionBannerContainer({ isRedesignedBlock }: ICallUnderDescriptionBannerContainerProps) {
  const agentAvatarUrl = useSelector(selectAgentAvatarUrl);

  const avatarNode = agentAvatarUrl ? (
    <AvatarWrapper>
      <Avatar src={agentAvatarUrl} type="agent" size={48} />
    </AvatarWrapper>
  ) : (
    <IconCoversation />
  );

  return (
    <CardSectionNew data-name="CallUnderDescriptionBannerContainer">
      {isRedesignedBlock ? (
        <CallUnderDescriptionBannerRedesigned
          title="Уточните у автора объявления всё, что интересно"
          fullWidth
          isOneLine
          agentAvatar={avatarNode}
        >
          <PhonesContainer size="M" isRedesignedBlock />
        </CallUnderDescriptionBannerRedesigned>
      ) : (
        <CallUnderDescriptionBanner subtitle="Вам ответят на все вопросы">
          <PhonesContainer size="M" />
        </CallUnderDescriptionBanner>
      )}
    </CardSectionNew>
  );
}
